export interface GetDiagnosticsAnswersParams {
  projectId: string
}

export interface GetDiagnosticsResultParams {
  projectId: string
}

export interface GetBlockDetailsParams {
  blockId: number
}

export interface GetQuestionDetailsParams {
  questionId: number
}

export interface PostCreateBlock {
  projectId: string
  blockId: number
  questionId: number
}

const endpoints = {
  getQuestion: 'Api/project_diag_create_block',
  getBlocks: 'api/v2/diagnostics/blocks',
  getBlocksOld: 'Api/project_diag_create_block',
  createBlock: ({ projectId, blockId, questionId }: PostCreateBlock): string => {
    return `api/v2/users/user-id/projects/${projectId}/diagnostics/blocks/${blockId}/questions/${questionId}/answer/`
  },
  getBlockDetails: ({ blockId }: GetBlockDetailsParams): string => {
    return `api/v2/diagnostics/blocks/${blockId}`
  },
  getQuestionDetails: ({ questionId }: GetQuestionDetailsParams): string => {
    return `api/v2/diagnostics/questions/${questionId}`
  },
  getAnswers: ({ projectId }: GetDiagnosticsAnswersParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/diagnostic/answers`
  },
  getResult: ({ projectId }: GetDiagnosticsResultParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/diagnostic/result`
  },
}

export default endpoints
